module.exports = __webpack_public_path__ + "assets/images/flags/hm.svg";